require('./brokerAlertsConfigCreate.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { AmountInput } = require('commonsComponents/amountInput');

// @components
const BrokerSearchInput = require('components/broker/brokerSearch/brokerSearchInput/brokerSearchInput');
const { LoadingSection } = require('commonsComponents/loadingSection');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')

// @utils
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @ContactCenter and Office validation
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
    BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION,
    BROKER_ALERTS_CONFIG_SELECT_RATE_TYPE_FOR_INDEX,
    BROKER_ALERT_CONFIGURATION_TYPE_IBEX_35_OPTION,
    BROKER_ALERT_FRACTION_LENGTH_POINTS_VALUE,
    BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_VALUE,
    BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_IBEX35,
    BROKER_ALERT_MAXIMUM_EURO_VALUE,
    BROKER_ALERT_MAXIMUM_PERCENTAGE_IBEX35,
    BROKER_ALERT_MAXIMUM_PERCENTAGE_VALUE,
    BROKER_ALERT_MAXIMUM_POINTS_VALUE,
    BROKER_ALERT_MINIMUM_PERCENTAGE_IBEX35,
    BROKER_ALERT_MINIMUM_PERCENTAGE_VALUE,
    BROKER_ALERT_MINIMUM_POINTS_VALUE,
    BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS,
    BROKER_ALERT_RATE_VALUE_CERO_EURO_PERCENTAGE_VALUE,
    BROKER_ALERT_MAXIMUN_INTEGER_PERCENTAGE_LENGTH,
    BROKER_ALERT_MAXIMUN_INTEGER_EURO_LENGTH,
    BROKER_ALERT_MAXIMUN_INTEGER_POINTS_LENGTH,
    BROKER_ALERT_MAXIMUN_INTEGER_PERCENTAGE_IBEX35_LENGTH,
    BROKER_ALERT_RATE_IBEX35_CERO_EURO_PERCENTAGE_VALUE,
    TYPE_ETFS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    BROKER_ALERT_CMY,
    BROKER_ALERT_CMN,
    BROKER_ALERT_VMN,
    BROKER_ALERT_VMY,
    BROKER_ALERT_BDV,
    BROKER_ALERT_BDP,
    BROKER_ALERT_SDV,
    BROKER_ALERT_SDP,
    BROKER_INPUT_SEARCH_WIDGET_PRODUCT,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    BROKER_TYPE_STOCKS_NEW_DECIMALS_MIN_VALUE
} = require('constants/index');

class BrokerAlertsConfigCreate extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSubmitAlert = this.handleSubmitAlert.bind(this);
        this.handleUpdateAlert = this.handleUpdateAlert.bind(this);
        this.handleUpdateIbex35Alert = this.handleUpdateIbex35Alert.bind(this);
        this.conditionalInput = this.conditionalInput.bind(this);
        this.setInputRate = this.setInputRate.bind(this);
        this.handleRetryRequestAlertsConditions = this.handleRetryRequestAlertsConditions.bind(
            this
        );
        this.state = { searched: false };
    }

    setInputRate(rate) {
        const { immAlertsConfig } = this.props;
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const selectedRateType = this.props.immAlertsConfig.getIn(['selectedValues', configurationType, 'rateType']);
        const isInteger = new RegExp(/^\d+$/);
        let selectedRate = 0;

        if (!isNaN(rate) &&  BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(selectedRateType) !== -1 && (rate >= BROKER_ALERT_MAXIMUM_PERCENTAGE_IBEX35 || rate >= BROKER_ALERT_MAXIMUM_PERCENTAGE_VALUE)) {
            selectedRate = (!isInteger.test(rate) && rate !== "") ? Math.round(rate) : rate;
        } else if (!isNaN(rate)) {
            selectedRate = rate;
        }

        this.props.onHandleInputRate(selectedRate);
    }

    buildAlertsCondition(alertsConditions, configurationType){
        const isConfigIbex35 = configurationType === BROKER_ALERT_CONFIGURATION_TYPE_IBEX_35_OPTION;
        const alertConditionsItems = alertsConditions.get('conditions').toJS().map(v => {
            switch (v.value) {
                case BROKER_ALERT_CMY:
                    return ({
                        label : isConfigIbex35 ? formatText('broker-alertsCondCmyIbex35') : formatText('broker-alertsCondCmy'),
                        value : v.value
                    });
                case BROKER_ALERT_CMN:
                    return ({
                        label : isConfigIbex35 ? formatText('broker-alertsCondCmnIbex35') : formatText('broker-alertsCondCmn'),
                        value : v.value
                    });
                case BROKER_ALERT_VMN:
                    return {
                        label: formatText('broker-alertsCondVmn'),
                        value: v.value
                    };
                case BROKER_ALERT_VMY:
                    return {
                        label: formatText('broker-alertsCondVmy'),
                        value: v.value
                    };
                case BROKER_ALERT_BDV:
                    return {
                        label: formatText('broker-alertsCondBdv'),
                        value: v.value
                    };
                case BROKER_ALERT_BDP:
                    return ({
                        label : isConfigIbex35 ? formatText('broker-alertsCondBdpIbex35') : formatText('broker-alertsCondBdp'),
                        value : v.value
                    });
                case BROKER_ALERT_SDV:
                    return {
                        label: formatText('broker-alertsCondSdv'),
                        value: v.value
                    };
                case BROKER_ALERT_SDP:
                    return ({
                        label : isConfigIbex35 ? formatText('broker-alertsCondSdpIbex35') : formatText('broker-alertsCondSdp'),
                        value : v.value
                    });
                default:
                    return '';
            }
        });
        return alertConditionsItems.filter(condition => condition.value);
    }

    buildAlertsConditionsDropdown(defaultIndexName) {
        const { immAlertsConditions, onHandleRateSelection, immAlertsConfig } = this.props;

        if (immAlertsConditions.get('isFetching')) {
            return <LoadingSection />;
        }

        if (immAlertsConditions.get('error')) {
            return (
                <div>
                    <OKButton
                        onClick={this.handleRetryRequestAlertsConditions}
                        modifier="link-complementary"
                        id="btnRetryGetAlertsConditions"
                    >
                        <FormattedText value="broker-getAlertConditionsError" />
                    </OKButton>
                </div>
            );
        }

        if (!immAlertsConditions.get('hasBeenFetched')) {
            return;
        }

        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const alertsConditions = this.buildAlertsCondition(immAlertsConditions, configurationType);
        const ratePlaceholder = formatText('broker-alertsConfigRatePlaceholder');
        let selectedRateType;
        let errorState;

        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
            selectedRateType = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateType']);
            errorState = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'rateTypeInput']);
        } else {
            selectedRateType = immAlertsConfig.getIn(['selectedValues', defaultIndexName, 'rateType']);
            errorState = immAlertsConfig.getIn(['selectedValues', defaultIndexName, 'errorFlags', 'rateTypeInput']);
        }

        return (
            <OKSelect
                onChange={onHandleRateSelection}
                options={alertsConditions}
                value={selectedRateType}
                searchable={false}
                placeholder={ratePlaceholder}
                errorState={errorState}
                errorMessage={formatText('broker-alertsConfigCreateRateTypeErrorEmptyMessage')}
            />
        );
    }

    buildProductSearch() {
        const { immAlertsConfig, searchState, onHandleSelection } = this.props;

        let results;
        if (!this.state.searched) {
            results = immAlertsConfig.get('customEditResult');
        } else {
            const hasStocks = searchState.get('results').some(item =>
                (item.get('type') === TYPE_STOCKS &&
                (item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE ||
                    item.getIn(['id', 'iso']) ===
                        SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK))
                );
            const hasEtfs = searchState.get('results').some(item =>
                item.get('type') === TYPE_ETFS &&
                item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE
                );
            results = searchState.get('results').filter(item => {
                if (
                    (item.get('label') === TYPE_STOCKS && hasStocks) ||
                    (item.get('label') === TYPE_ETFS && hasEtfs) ||
                    item.get('label') === TYPE_WARRANTS ||
                    (item.get('type') === TYPE_STOCKS ) ||
                    (item.get('type') === TYPE_ETFS ) ||
                    item.get('type') === TYPE_WARRANTS
                ) {
                    return item;
                }
            });
        }

        return (
            <div>
                <label className="broker-alerts-config-create__label">
                    {formatText('broker-alertsConfigSearchLabel')}
                </label>
                <div className="broker-alerts-config-create__instructions">
                    {formatText('broker-alertsConfigInstructionsValue')}
                </div>
                <BrokerSearchInput
                    results={results}
                    selectedValue={immAlertsConfig.getIn(['selectedValues', 'stocks', 'productId'])}
                    isLoading={searchState.get('isFetching')}
                    onSelection={onHandleSelection}
                    onSearch={this.handleSearch}
                    noResultsText={formatText('broker-searchEmptyText')}
                    placeholder={formatText('broker-alertsConfigSearchPlaceholder')}
                    errorState={immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'productInput'])}
                    errorMessage={formatText('broker-alertsConfigCreateRateProductErrorEmptyMessage')}
                    modifier={BROKER_INPUT_SEARCH_WIDGET_PRODUCT}
                    resetWhenMounting={false}
                />
            </div>
        );
    }

    buildTypeError() {
        const { immAlertsConfig } = this.props;
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        let errorMessage = null;
        let rateType;
        let rateValue;

        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
            rateType = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateType']);
            rateValue = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateValue']);
        } else {
            rateType = immAlertsConfig.getIn(['selectedValues', 'ibex35', 'rateType']);
            rateValue = immAlertsConfig.getIn(['selectedValues', 'ibex35', 'rateValue']);
        }

        const hasMoneyAmountConditions =
            BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(rateType) === -1;
        const hasPercentConditions = BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(rateType) > -1;

        if (hasMoneyAmountConditions) {
            const isIbex35ptionSelected = (
                BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(rateType) === -1 &&
                configurationType === BROKER_ALERT_CONFIGURATION_TYPE_IBEX_35_OPTION
            );

            if (isIbex35ptionSelected && rateValue === '') {
                errorMessage = formatText('broker-alertsConfigCreateRateIbex35ErrorEmptyMessage');
            } else if (rateValue === '') {
                errorMessage = formatText('broker-alertsConfigCreateRateValueErrorEmptyMessage');
            }
            if (rateValue > BROKER_ALERT_MAXIMUM_EURO_VALUE) {
                errorMessage = formatText('broker-alertsConfigCreateRateValueTooHigh');
            }
        }
        if (hasPercentConditions) {
            if (rateValue === '') {
                errorMessage = formatText(
                    'broker-alertsConfigCreateRatePercentageErrorEmptyMessage'
                );
            }
            if (rateValue > BROKER_ALERT_MAXIMUM_PERCENTAGE_VALUE) {
                errorMessage = formatText('broker-alertsConfigCreateRatePercentageTooHigh');
            }
        }

        if (!isNaN(parseFloat(rateValue)) && (parseFloat(rateValue) <= BROKER_ALERT_RATE_VALUE_CERO_EURO_PERCENTAGE_VALUE)) {
            if (hasPercentConditions) {
                errorMessage = formatText('broker-alertsConfigCreateRatePercentageErrorAboveZeroMessage');
            }
            else {
                if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
                    errorMessage = formatText('broker-alertsConfigCreateRateValueErrorAboveZeroMessage');
                } else {
                    errorMessage = formatText('broker-alertsConfigCreateRatePointsErrorAboveZeroMessage');
                }
            }
        }

        return errorMessage;
    }

    conditionalInput(selectedRateType, selectedRateValue, configurationType, defaultIndexName) {
        const { immAlertsConfig } = this.props;
        const errorMessage = this.buildTypeError();
        let errorState;
        let label;
        let minValue;
        let maxValue;
        let maxFractionLength;
        let maxIntegerLength;

        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
            errorState = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'rateValueInput']);
        } else {
            errorState = immAlertsConfig.getIn(['selectedValues', defaultIndexName, 'errorFlags', 'rateValueInput']);
        }

        if (BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(selectedRateType) === -1 &&
            configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) { // Configuración para Euros
            label = formatText('broker-alertsConfigRateTypeEurosLabel');
            minValue = BROKER_TYPE_STOCKS_NEW_DECIMALS_MIN_VALUE;
            maxValue = BROKER_ALERT_MAXIMUM_EURO_VALUE;
            maxFractionLength = BROKER_TYPE_STOCKS_NEW_DECIMALS;
            maxIntegerLength = BROKER_ALERT_MAXIMUN_INTEGER_EURO_LENGTH;
        } else if (BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(selectedRateType) === -1 &&
            configurationType === BROKER_ALERTS_CONFIG_SELECT_RATE_TYPE_FOR_INDEX) { // Configuración para Puntos
            label = formatText('broker-alertsConfigRateTypePointsLabel');
            minValue = BROKER_ALERT_MINIMUM_POINTS_VALUE;
            maxValue = BROKER_ALERT_MAXIMUM_POINTS_VALUE;
            maxFractionLength = BROKER_ALERT_FRACTION_LENGTH_POINTS_VALUE;
            maxIntegerLength = BROKER_ALERT_MAXIMUN_INTEGER_POINTS_LENGTH;
        } else if (configurationType === BROKER_ALERTS_CONFIG_SELECT_RATE_TYPE_FOR_INDEX) { //Configuración para porcentajes de IBEX35
            label = formatText('broker-alertsConfigRateTypePercentageLabel');
            minValue = BROKER_ALERT_MINIMUM_PERCENTAGE_IBEX35;
            maxValue = BROKER_ALERT_MAXIMUM_PERCENTAGE_IBEX35;
            maxFractionLength = BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_IBEX35;
            maxIntegerLength = BROKER_ALERT_MAXIMUN_INTEGER_PERCENTAGE_IBEX35_LENGTH;
        } else { //Configuración para porcentajes de valores
            label = formatText('broker-alertsConfigRateTypePercentageLabel');
            minValue = BROKER_ALERT_MINIMUM_PERCENTAGE_VALUE;
            maxValue = BROKER_ALERT_MAXIMUM_PERCENTAGE_VALUE;
            maxFractionLength = BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_VALUE;
            maxIntegerLength = BROKER_ALERT_MAXIMUN_INTEGER_PERCENTAGE_LENGTH;
        }

        return (
            <AmountInput
                id="create-alert_Amount"
                label={label}
                min={minValue}
                max={maxValue}
                amount={selectedRateValue}
                callback={this.setInputRate}
                error={errorState || this.handleSubmitAlert(true)}
                errorMsg={errorMessage}
                maxFractionLength={maxFractionLength}
                maxBackEndFractionLength={maxFractionLength}
                showBlurZero={true}
                keepZeroAndEmpty={true}
                inlineError={true}
                maxIntegerLength={maxIntegerLength}
                language={getLanguage()}
            />
        );
    }

    handleRetryRequestAlertsConditions() {
        this.props.retryRequestAlertsConditions();
    }

    handleSearch(ev) {
        if (!this.state.searched) {
            this.setState({ searched: true });
        }
        this.props.onHandleSearch(ev);
    }

    handleSubmitAlert(check) {
        const { immAlertsConfig } = this.props;
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const value = immAlertsConfig.getIn(['selectedValues', configurationType, 'rateValue']);
        const type = immAlertsConfig.getIn(['selectedValues', configurationType, 'rateType']);

        const hasMoneyAmountConditions =
            BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(type) === -1;
        const hasPercentConditions = BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(type) > -1;

        if ( configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION &&
            ((hasMoneyAmountConditions && value > BROKER_ALERT_MAXIMUM_EURO_VALUE) ||
            (hasPercentConditions && value > BROKER_ALERT_MAXIMUM_PERCENTAGE_VALUE) ||
            ((hasMoneyAmountConditions || hasPercentConditions) &&
                value === BROKER_ALERT_RATE_IBEX35_CERO_EURO_PERCENTAGE_VALUE))) {
            if (check === true) {
                return true;
            }
        } else if ( configurationType === BROKER_ALERT_CONFIGURATION_TYPE_IBEX_35_OPTION &&
            ((hasMoneyAmountConditions && value > BROKER_ALERT_MAXIMUM_POINTS_VALUE) ||
            (hasPercentConditions && value > BROKER_ALERT_MAXIMUM_PERCENTAGE_IBEX35) ||
            ((hasMoneyAmountConditions || hasPercentConditions) &&
                value === BROKER_ALERT_RATE_VALUE_CERO_EURO_PERCENTAGE_VALUE))){
            if (check === true) {
                return true;
            }
        }
        if (check === true) {
            return !check;
        }
        this.props.onHandleSubmitAlert();
    }

    handleUpdateAlert() {
        const { immAlertsConfig, onHandleEditAlert } = this.props;

        const productName = immAlertsConfig.getIn(['selectedValues', 'stocks', 'productName']);
        const productId = immAlertsConfig.getIn(['selectedValues', 'stocks', 'productId']);
        const rateType = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateType']);
        const rateLabel = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateLabel']);
        const rateValue = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateValue']);
        const alertId = immAlertsConfig.getIn(['selectedValues', 'alertId']);

        onHandleEditAlert({ productName, productId, rateType, rateLabel, rateValue, alertId });
    }

    handleUpdateIbex35Alert() {
        const { immBrokerExchangeIndexes, onHandleUpdateIndexAlert } = this.props;
        const indexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");
        onHandleUpdateIndexAlert(indexName);
    }

    handleIndexSubmit = () => {
        const { immBrokerExchangeIndexes, onhandleIndexSubmit } = this.props;
        const indexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");
        onhandleIndexSubmit(indexName);
    }

    buildAlertIndexDropdown = () => {
        const { immBrokerExchangeIndexes, onHandleConfigurationTypeChange, immAlertsConfig } = this.props;
        const defaultIndexName = immBrokerExchangeIndexes.get('defaultIndex') && immBrokerExchangeIndexes.get('defaultIndex');
        const indexNameWithoutSpace = defaultIndexName && defaultIndexName.replace(/ +/g, "");
        const labelName = immAlertsConfig.getIn(['selectedValues', 'configurationLabel']);
        const ratePlaceholder = formatText('broker-alertsConfigRatePlaceholder');
    
        const dropDownOptions = [{
            value: BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION,
            label: formatText('broker-alertsConfigTypeStocksOptionLabel')
        },{
            value: indexNameWithoutSpace,
            label: defaultIndexName //formatText(`broker-alertsConfigType${indexName}Label`)
        }];

        return (<OKSelect
            onChange={onHandleConfigurationTypeChange}
            options={dropDownOptions}
            placeholder={ratePlaceholder}
            value={labelName}
            searchable={false}
            errorMessage={formatText('broker-alertsConfigCreateRateTypeErrorEmptyMessage')}
        />);
    }

    render() {
        const {
            immAlertsConfig,
            immBrokerExchangeIndexes,
            onHandleCancelNewAlert,
            editSearchResult
        } = this.props;

        const alertsConfigInstructionConditions = formatText('broker-alertsConfigInstructionConditions');
        const alertsConfigRateLabel = formatText('broker-alertsConfigRateLabel');
        const cancelText = editSearchResult ? formatText('broker-alertsConfigUpdateCancel') : formatText('broker-alertsConfigCreateCancel');
        const submitText = editSearchResult ? formatText('broker-alertsConfigUpdateSubmit') : formatText('broker-alertsConfigCreateSubmit');
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const alertIndexDropdown = this.buildAlertIndexDropdown();
        const defaultIndexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");
        const alertsConditionsDropdown = this.buildAlertsConditionsDropdown(defaultIndexName);
        const isOfficeAndCC = __CONTACT_CENTER__ && isPrintOfficeMode();

        let selectedRateType;
        let selectedRateValue;
        let productSearchBlock;
        let printerValue;
        let handleSubmitEditCallback;
        let conditionalInput;
        
        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION){
            selectedRateType = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateType']);
            selectedRateValue = immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateValue']);
            printerValue = formatText('broker-alertsConfigTypeStocksOptionLabel');
            productSearchBlock = this.buildProductSearch()
            handleSubmitEditCallback = editSearchResult ? this.handleUpdateAlert : this.handleSubmitAlert;
        } else {
            selectedRateType = immAlertsConfig.getIn(['selectedValues', defaultIndexName, 'rateType']);
            selectedRateValue = immAlertsConfig.getIn(['selectedValues', defaultIndexName, 'rateValue']);
            printerValue = formatText('broker-alertsConfigTypeIbex35OptionLabel');
            handleSubmitEditCallback = editSearchResult ? this.handleUpdateIbex35Alert : this.handleIndexSubmit;
        }

        if (selectedRateType) {
            conditionalInput = this.conditionalInput(selectedRateType, selectedRateValue, configurationType, defaultIndexName);
        }

        return (
            <div className="broker-alerts-config-create row">
                <div className="col-lg-8 broker-alerts-config-create__configuration-options">
                    <FormattedText value="broker-alertsConfigSelectConfigurationMessage" />
                    {alertIndexDropdown}
                </div>
                { isOfficeAndCC && <div className="col-lg-12 broker-alerts-config-create__printer-value">
                    {printerValue}
                </div> }
                <div className="col-lg-12">
                    {productSearchBlock}
                </div>

                <div className="col-lg-8 broker-alerts-config-create__condition-options">
                    <label className="broker-alerts-config-create__label">
                        {alertsConfigRateLabel}
                    </label>
                    <div className="broker-alerts-config-create__condition-instructions">
                        {alertsConfigInstructionConditions}
                    </div>
                    {alertsConditionsDropdown}
                </div>
                <div className="col-lg-4">
                    {conditionalInput}
                </div>
                { isOfficeAndCC && <div className="col-lg-4">
                    <PrinterPreviewManager />
                </div> }
                <div className="col-lg-12">
                    <div className="broker-alerts-config-create__buttons-row">
                        <div className="broker-alerts-config-create__submit">
                            <ContactCenterRender>
                                <PrinterPreviewManagerButton
                                    id="btnSubmitNewAlert"
                                    modifier="secondary"
                                    loading={
                                        immAlertsConfig.get('isCreatingAlert') ||
                                        immAlertsConfig.get('isEditingAlert')
                                    }
                                    onClick={handleSubmitEditCallback}
                                >
                                    {submitText}
                                </PrinterPreviewManagerButton>
                            </ContactCenterRender>
                            <WebappRender>                            
                                <OKButton
                                    id="btnSubmitNewAlert"
                                    modifier="secondary"
                                    loading={
                                        immAlertsConfig.get('isCreatingAlert') ||
                                        immAlertsConfig.get('isEditingAlert')
                                    }
                                    onClick={handleSubmitEditCallback}
                                >
                                    {submitText}
                                </OKButton>
                            </WebappRender>
                        </div>

                        <div className="broker-alerts-config-create__cancel">
                            <OKButton
                                id="btnCancelNewAlert"
                                modifier="link-ghost"
                                onClick={onHandleCancelNewAlert}
                            >
                                {cancelText}
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerAlertsConfigCreate.propTypes = {
    searchState: PropTypes.object.isRequired,
    onHandleConfigurationTypeChange: PropTypes.func.isRequired,
    onhandleIndexSubmit: PropTypes.func.isRequired,
    onHandleSearch: PropTypes.func.isRequired,
    onHandleSelection: PropTypes.func.isRequired,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    immAlertsConfig: PropTypes.object.isRequired,
    onHandleRateSelection: PropTypes.func.isRequired,
    onHandleInputRate: PropTypes.func.isRequired,
    onHandleCancelNewAlert: PropTypes.func.isRequired,
    onHandleSubmitAlert: PropTypes.func.isRequired,
    onHandleEditAlert: PropTypes.func.isRequired,
    onHandleUpdateIndexAlert: PropTypes.func.isRequired,
    retryRequestAlertsConditions: PropTypes.func.isRequired,
    editSearchResult: PropTypes.object,
    immAlertsConditions: PropTypes.object.isRequired
};

module.exports = BrokerAlertsConfigCreate;
